import React from 'react';
import PropTypes from 'prop-types';

import * as S from './IframeView.styles';

export const IframeView = ({ src, title, className }) => {
	return <S.Frame className={className} src={src} title={title} />;
};

IframeView.propTypes = {
	src: PropTypes.string.isRequired,
	title: PropTypes.string,
	className: PropTypes.string,
};
